class DongerdiFaq extends HTMLElement {
  #abortController = new AbortController();
  #activeCategory = 'all';

  connectedCallback() {
    const signal = this.#abortController.signal;
    this.searchInput = this.querySelector('[data-dd-faq-search]');
    this.items = Array.from(this.querySelectorAll('[data-dd-faq-item]'));
    this.filters = Array.from(this.querySelectorAll('[data-dd-faq-filter]'));
    this.emptyState = this.querySelector('[data-dd-faq-empty]');

    this.searchInput?.addEventListener('input', () => this.#applyFilters(), { signal });

    this.filters.forEach((button) => {
      button.addEventListener(
        'click',
        () => {
          this.#activeCategory = button.dataset.category || 'all';
          this.filters.forEach((filter) => {
            const isActive = filter === button;
            filter.classList.toggle('is-active', isActive);
            filter.setAttribute('aria-pressed', isActive.toString());
          });
          this.#applyFilters();
        },
        { signal }
      );
    });

    if (this.dataset.singleOpen !== 'false') {
      this.items.forEach((item) => {
        item.addEventListener(
          'toggle',
          () => {
            if (!item.open) return;
            this.items.forEach((otherItem) => {
              if (otherItem !== item) otherItem.open = false;
            });
          },
          { signal }
        );
      });
    }
  }

  disconnectedCallback() {
    this.#abortController.abort();
  }

  #applyFilters() {
    const query = this.searchInput?.value.trim().toLocaleLowerCase() || '';
    let visibleCount = 0;

    this.items.forEach((item) => {
      const matchesCategory =
        this.#activeCategory === 'all' || item.dataset.category === this.#activeCategory;
      const matchesSearch = !query || item.textContent.toLocaleLowerCase().includes(query);
      const isVisible = matchesCategory && matchesSearch;
      item.hidden = !isVisible;
      if (!isVisible) item.open = false;
      if (isVisible) visibleCount += 1;
    });

    if (this.emptyState) this.emptyState.hidden = visibleCount > 0;
  }
}

if (!customElements.get('dongerdi-faq')) {
  customElements.define('dongerdi-faq', DongerdiFaq);
}
